import React from 'react';

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

type Author = {
  id: number;
  name: string;
};

type Props = {
  authors: Author[];
  selectedAuthorId: number | undefined;
  onAuthorChange: (authorId: number | undefined) => void;
};

export const AuthorSelector: React.FC<Props> = ({ authors, selectedAuthorId, onAuthorChange }) => {
  const handleChange = (event: SelectChangeEvent<number | string>) => {
    const value = event.target.value;
    onAuthorChange(value === '' ? undefined : Number(value));
  };

  if (authors.length === 0) {
    return null;
  }

  return (
    <FormControl sx={{ minWidth: 250 }}>
      <InputLabel id="author-select-label">Автор</InputLabel>
      <Select
        labelId="author-select-label"
        id="author-select"
        value={selectedAuthorId || ''}
        label="Автор"
        onChange={handleChange}
      >
        {authors.map((author) => (
          <MenuItem key={author.id} value={author.id}>
            {author.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
